import { Fragment, useEffect, useState } from "react";
import Spinner from "../Spinner";
import { useAppSelector, useCustomImage, useConfig } from "../../hooks";
import classes from "../../styles/LoadingScreen.module.css";

const LoadingScreen: React.FC = () => {
  const { loadingScreen } = useAppSelector((state) => state);
  const { loadingScreen: config } = useConfig();
  const [isLoaded, setIsLoaded] = useState(false);
  const srcs = [
    useCustomImage(config.main.image),
    useCustomImage(config.background.image),
    useCustomImage(config.logo.image),
    useCustomImage(config.effect.image),
  ];

  useEffect(() => {
    let count = 0;
    srcs.forEach((src) => {
      const image = new Image();
      const loadHandler = () => {
        count = count + 1;
        setIsLoaded(count === srcs.length);
      };
      image.onload = loadHandler;
      image.onerror = loadHandler;
      image.src = src;
    });
  }, []);

  const mainStyle = {
    backgroundImage: `url(${useCustomImage(config.main.image || "")})`,
  };
  const effectStyle = {
    backgroundImage: `url(${useCustomImage(config.effect.image || "")})`,
  };
  const logoStyle = {
    backgroundImage: `url(${useCustomImage(config.logo.image || "")})`,
    // maxWidth property is kept for legacy purposes
    maxWidth: config.logo.maxWidth,
    ...(config.logo.style || {}),
  };
  const bgStyle = {
    backgroundImage: `url(${useCustomImage(config.background.image || "")})`,
    backgroundColor: config.main.color,
  };

  if (!loadingScreen.visible) return null;

  let content;
  // if (!isLoaded || details.gameName === "") {
  if (!isLoaded) {
    content = (
      <div className={classes.spinner}>
        <Spinner size={80} stroke={3} name="loading" visible={true} />
      </div>
    );
  } else {
    content = (
      <Fragment>
        <div className={classes.background} style={bgStyle}></div>
        <div className={classes.logo} style={logoStyle}></div>
        <div className={classes["small-logo"]}></div>
        <div className={classes.main} style={mainStyle}></div>
        <div className={classes.effect} style={effectStyle}></div>
        <div className={classes.effect} style={effectStyle}></div>
      </Fragment>
    );
  }

  return (
    <div id="loading">
      {content}
      <div className={classes.progress}>
        <div
          className={classes.full}
          style={{
            ...config.progress.full,
            width: loadingScreen.progress + "%",
          }}
        ></div>
        <div className={classes.empty} style={config.progress.empty}></div>
      </div>
    </div>
  );
};

export default LoadingScreen;
